import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { NewGetSiteEventHistory, NewGetSiteEventHistoryResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<NewGetSiteEventHistoryResponse, NewGetSiteEventHistoryResponse>) => response?.data?.historyItems;
const getError = (response?: SWRResponse<NewGetSiteEventHistoryResponse, NewGetSiteEventHistoryResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<NewGetSiteEventHistoryResponse, NewGetSiteEventHistoryResponse>) => ({});

const useGetSiteEventHistory = (query?: Partial<NewGetSiteEventHistory>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new NewGetSiteEventHistory(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetSiteEventHistory;